import { BaseService } from "./BaseService";
import { CognitoUser } from "amazon-cognito-identity-js";
import { Platform } from "react-native";

const config = require("../../config");

export class AuthService extends BaseService {
  constructor(
    public cognitoUser: CognitoUser,
    public dispatch = (tokens: any) => {},
    public url = config.authService
  ) {
    super(url, cognitoUser, dispatch);
  }

  async sendInvite(username: string) {
    const response = await fetch(`${config.domusoApiService}/v1/resend_invite`, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      body: JSON.stringify({ username: username }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  }

  async validatePassword(username: string, password: string) {
    const requestBody = {
      username,
      password,
    };
    const path = "validatePassword";
    let response;
    if (Platform.OS == "web") {
      response = await this.makePostSimpleRequest(path, JSON.stringify(requestBody));
    } else {
      response = await this.makePostRequest(path, requestBody);
    }
    await this.logger.log({ response });
    return response;
  }
}
